export default __webpack_public_path__ + "static/media/insee-login.f86a07af.png";